

import request from '@/utils/stakeRequest'

const KEYBASE_USER_LOOKUP_URL = 'https://keybase.io/_/api/1.0/user/lookup.json'

//list
export function validatorsList(data) {
  return request({
    url: '/cosmos/staking/v1beta1/validators',
    method: 'get',
    params: data,
  })
}

export function getDelegationList(data){
  return request({
    url: `/cosmos/staking/v1beta1/validators/${data}/delegations`,
    method: 'get',
  })
}

//Rewards
export function getRewards(validator_address) {
  return request({
    url: `/cosmos/distribution/v1beta1/validators/${validator_address}/outstanding_rewards`,
    method: 'get',
  })
}

export function getShares(validator_addr,delegator_addr) {
  return request({
    url: `/cosmos/staking/v1beta1/validators/${validator_addr}/delegations/${delegator_addr}`,
    method: 'get',
  })
}
export function getidentity(validator_addr) {
  return request({
    url: `/cosmos/staking/v1beta1/validators/${validator_addr}`,
    method: 'get',
  })
}
//
export function getBalances(address) {
  return request({
    url: `/cosmos/bank/v1beta1/balances/${address}`,
    method: 'get',
  })
}

export function getUserInfo(val) {
  return request({
    url: `${KEYBASE_USER_LOOKUP_URL}?key_suffix=${val}`,
    method: 'get',
  })
}

export function poolVal(delegator_addr) {
  return request({
    url: `/cosmos/staking/v1beta1/delegationstotal/${delegator_addr}`,
    method: 'get',
  })
}

export function alloutstandingRewards(delegator_addr) {
  return request({
    url: `/cosmos/distribution/v1beta1/delegators/${delegator_addr}/rewards`,
    method: 'get',
  })
}

export function profileList(data,delegator_addr) {
  return request({
    url: `/cosmos/staking/v1beta1/delegations/${delegator_addr}`,
    method: 'get',
    params: data,
  })
}

export function profileRewards(delegator_address,validator_address) {
  return request({
    url: `/cosmos/distribution/v1beta1/delegators/${delegator_address}/rewards/${validator_address}`,
    method: 'get',
  })
}







